import { render, staticRenderFns } from "./exhibition-order.vue?vue&type=template&id=1352f8a3&scoped=true&"
import script from "./exhibition-order.vue?vue&type=script&lang=js&"
export * from "./exhibition-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352f8a3",
  null
  
)

export default component.exports